import { api } from './api';
import { jobVisibilityService, type JobVisibilityConfigDto } from './jobVisibilityService';

export interface JobStatistics {
  enqueued: number;
  processing: number;
  succeeded: number;
  failed: number;
  deleted: number;
  scheduled: number;
  servers: number;
  recurring: number;
  queues: number;
}

export interface JobInfo {
  id: string;
  name: string;
  displayName: string;
  queue: string;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
  failedAt: string | null;
  exceptionMessage: string | null;
  state: string;
  duration: string | null;
}

export interface PagedJobResult {
  items: JobInfo[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface JobsFilter {
  status?: string;
  jobType?: string;
  page?: number;
  pageSize?: number;
}

export const JOB_STATUS_LABELS: Record<string, string> = {
  Processing: 'Em Processamento',
  Enqueued: 'Na Fila',
  Failed: 'Falhou',
  Succeeded: 'Concluido',
  Scheduled: 'Agendado',
  Deleted: 'Removido',
};

class JobMonitoringService {
  async getStatistics(): Promise<JobStatistics> {
    const response = await api.get<JobStatistics>('/job-monitoring/statistics');
    return response.data;
  }

  async getJobs(params: JobsFilter): Promise<PagedJobResult> {
    const response = await api.get<PagedJobResult>('/job-monitoring/jobs', { params });
    return response.data;
  }

  async retryJob(id: string): Promise<void> {
    await api.post(`/job-monitoring/jobs/${id}/retry`);
  }

  async deleteJob(id: string): Promise<void> {
    await api.delete(`/job-monitoring/jobs/${id}`);
  }

  async getJobTypeOptions(): Promise<{ value: string; label: string }[]> {
    const configs = await jobVisibilityService.getAll();
    return configs
      .filter(c => c.isVisible)
      .map(c => ({ value: c.jobTypeName, label: c.displayName }));
  }
}

export const jobMonitoringService = new JobMonitoringService();
